import { render, staticRenderFns } from "./EditAddressNote.vue?vue&type=template&id=55383e3c&lang=pug"
import script from "./EditAddressNote.vue?vue&type=script&lang=js"
export * from "./EditAddressNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports